'use client';

import Stack from '@enlighten/design-system/dist/Stack';
import Section1 from '@enlighten/landing/dist/hanwha/@section1';
import Section2 from '@enlighten/landing/dist/hanwha/@section2';
import Section3 from '@enlighten/landing/dist/hanwha/@section3';
import Section4 from '@enlighten/landing/dist/hanwha/@section4';
import Section5 from '@enlighten/landing/dist/hanwha/@section5';
import Section6 from '@enlighten/landing/dist/hanwha/@section6';
import Section7 from '@enlighten/landing/dist/hanwha/@section7';
import Section8 from '@enlighten/landing/dist/hanwha/@section8';
import Section9 from '@enlighten/landing/dist/hanwha/@section9';
import { useRouter } from 'next/navigation';

const PHONE_NUMBER = '1644-9664';

export default function Page() {
	const router = useRouter();

	const onClickPhone = () => {
		router.push(`tel:${PHONE_NUMBER}`);
	};

	const onClickOnline = () => {
		window.open('https://forms.gle/EwnoSohUbPmG4Qwq8', '_blank');
	};

	return (
		<Stack component="div" id="hanwha">
			<Section1 onClickPhone={onClickPhone} onClickOnline={onClickOnline} />
			<Section2 />
			<Section3 />
			<Section4 />
			<Section5 />
			<Section6 />
			<Section7 />
			<Section8 onClickPhone={onClickPhone} onClickOnline={onClickOnline} />
			<Section9 />
		</Stack>
	);
}
